import React from 'react';
import { Icon } from '@hai/ui-react';
import { useTranslation } from 'react-i18next';
import { StreamViewModel } from './stream/stream-models';
import { DecoderViewModel } from './decoder/decoder-model';
import { PushButton } from 'src/js/component/base/push-button';

interface HeaderStatsRowProps {
  data: StreamViewModel | DecoderViewModel;
  classPrefix: string; // 'stream' or 'decoder'
}

function isStreamViewModel(data: any): data is StreamViewModel {
  return 'protocol' in data;
}

const HeaderStatsRow: React.FC<HeaderStatsRowProps> = ({ data, classPrefix }) => {
  const { t } = useTranslation();

  return (
    <div className={`${classPrefix}-stats-row d-flex justify-content-end text-right`}>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.id')}</div>
        <PushButton className="small stat-value">{data?.id ?? 'N/A'}</PushButton>
      </div>
      {isStreamViewModel(data) && (
        <div className={`${classPrefix}-stat-group`}>
          <div className="stat-label">{t('statistics.header.statisticsInformation.type')}</div>
          <div className="stat-value">
            {data?.protocol?.includes('SRT') ? (
              <Icon iconname="BadgeStreamSRT" />
            ) : data?.protocol?.includes('UDP') ? (
              <Icon iconname="BadgeStreamUDP" />
            ) : data?.protocol?.includes('RTP') ? (
              <Icon iconname="BadgeStreamRTP" />
            ) : (
              t('statistics.header.statisticsInformation.unknown')
            )}
          </div>
        </div>
      )}
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.status')}</div>
        <div className="stat-value">{data?.status ?? t('statistics.header.statisticsInformation.unknown')}</div>
      </div>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.uptime')}</div>
        <div className="stat-value">{data?.stats?.uptime ?? '0s'}</div>
      </div>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.lastReset')}</div>
        <div className="stat-value">{data?.stats?.lastReset ?? 'N/A'}</div>
      </div>
    </div>
  );
};

export { HeaderStatsRow };
